/* eslint-disable react/jsx-key */
import React from 'react';
import { Checkbox, Form } from 'antd-v5';
import { SettingsContent } from '../../../components/SettingsContent';

export const OptionalKioskFields = ({ form, showCustomFields }) => {
  const showEmail = Form.useWatch('show_email', form);
  return (
    <SettingsContent
      title="Optional Kiosk Fields"
      description="Below are optional fields that can be added to show in kiosk. Check the box to add the field and uncheck it to remove."
      className="m-btm-16"
    >
      <Form.Item name="show_birthday" noStyle valuePropName="checked">
        <Checkbox>Birthday</Checkbox>
      </Form.Item>
      <Form.Item name="show_anniversary" noStyle valuePropName="checked">
        <Checkbox>Anniversary</Checkbox>
      </Form.Item>
      {showCustomFields && (
        <>
          <Form.Item name="show_email" noStyle valuePropName="checked">
            <Checkbox>Email</Checkbox>
          </Form.Item>
          <div className="flex-row items-center">
            <div className="m-left-23">
              <Form.Item name="email_required" noStyle valuePropName="checked">
                <Checkbox disabled={!showEmail}>Require Email</Checkbox>
              </Form.Item>
            </div>
          </div>
          <Form.Item name="show_address" noStyle valuePropName="checked">
            <Checkbox>Address</Checkbox>
          </Form.Item>
        </>
      )}
    </SettingsContent>
  );
};
